module.exports = __webpack_public_path__ + "img/look_more_mind.940a3c49.svg";